import React from "react";
import { HousingSkeletonItem } from "./HousingSkeletonItem";
import "./styles.css";
import { Skeleton } from "../../../components/common/Skeleton";
import { PageNavigation } from "../../../components/common/PageNavigation";

export const HousingsSkeleton = () => {
  return (
    <div className="housings_container housings_container-skeleton">
      <PageNavigation />

      <div className="housings-skeleton_header">
        <Skeleton className="housings-skeleton_heading" />
        <Skeleton className="housings-skeleton_text" />
      </div>
      <div className="housings-skeleton_toolbar">
        <Skeleton className="housings-skeleton_tabs" />
        <Skeleton className="housings-skeleton_search-bar" />
        <Skeleton className="housings-skeleton_filter-button" />
      </div>
      <div className="housings_list">
          {Array.from({ length: 6 }, (_, index) => (
            <HousingSkeletonItem key={index} />
          ))}
      </div>
    </div>
  );
};
